// extracted by mini-css-extract-plugin
export default {"buttons":"Settings_buttons__C7q+C"};